import { addSimCardBatch } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddSimCardBatch = () => {
    const entityUpdater = useEntityQueryUpdate();
    const mutation = useMutation({
        mutationKey: 'add_simcards',
        mutationFn: (model) => addSimCardBatch(model),
        onSuccess: (data) => {
            data.forEach((x) => {
                entityUpdater([['sim_cards'], ['sim_card', x]], x);
            });

            notifications.show({
                title: 'Success',
                message: 'Successfully added sim cards.',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddSimCardBatch;
